/**
 * Datasource management utility.
 * Store, retrieve, and modify datsource definitions using simple placeholders for dynamic parameters.  Placeholders can be configured with default values inline.
 * @name datasource-manager
 * @type {Object}
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([
            './DatasourceManager', 
            './env'
        ],factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('./DatasourceManager'), 
            require('./env')
        );
    }
})(this, function (DatasourceManager, manageEnv) {

    /** Public API **/  
    var sharedInstance = new DatasourceManager();
    sharedInstance.manageEnv = manageEnv;

    return sharedInstance;
});